"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _fileUpload = _interopRequireDefault(require("./fileUpload.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FileUploadContainer = _styledComponents.default.div.withConfig({
  displayName: "FileUpload__FileUploadContainer",
  componentId: "sc-1sdzywh-0"
})([""]);
var LabelContainer = _styledComponents.default.label.withConfig({
  displayName: "FileUpload__LabelContainer",
  componentId: "sc-1sdzywh-1"
})(function (_ref) {
  var theme = _ref.theme;
  return "\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    padding: ".concat(theme.space.tiny, " ").concat(theme.space.normal, ";\n    border: 1px solid ").concat(theme.colors.greyLight, ";\n    border-radius: ").concat(theme.borderRadius.XLarge, ";\n    ");
});
var FileIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "FileUpload__FileIcon",
  componentId: "sc-1sdzywh-2"
})(["margin-right:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.XSmall;
});
var FileDescription = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "FileUpload__FileDescription",
  componentId: "sc-1sdzywh-3"
})(["margin-top:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
});
var FileUpload = function FileUpload(props) {
  var id = props.id,
    onFileChange = props.onFileChange,
    label = props.label,
    description = props.description,
    icon = props.icon,
    theme = props.theme,
    customProperties = props.customProperties,
    accessible = props.accessible;
  var _useState = (0, _react.useState)(label),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    fileName = _useState2[0],
    setFileName = _useState2[1];
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var onFileHandler = function onFileHandler(event) {
    var file = event.target.files[0];
    setFileName(file.name);
    if (onFileChange) {
      onFileChange(file);
    }
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(FileUploadContainer, customProperties, /*#__PURE__*/_react.default.createElement(LabelContainer, {
      htmlFor: id,
      tabIndex: tabIndex
    }, /*#__PURE__*/_react.default.createElement(FileIcon, {
      icon: icon,
      fontsize: "medium",
      color: "greyDark",
      accessible: false
    }), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "sub",
      textLimit: 30,
      theme: theme,
      accessible: false
    }, fileName)), /*#__PURE__*/_react.default.createElement("input", {
      id: id,
      type: "file",
      hidden: true,
      onChange: onFileHandler
    }), description && /*#__PURE__*/_react.default.createElement(FileDescription, {
      display: "block",
      color: "greyDark",
      type: "small"
    }, description));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
FileUpload.propTypes = _fileUpload.default.PropTypes;
FileUpload.defaultProps = _fileUpload.default.DefaultProps;
var _default = FileUpload;
exports.default = _default;